import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { __ } from '@wordpress/i18n';

// store
import { storeGet, storeSet } from '../store';

// helpers
import { EMPTY_SELECTION } from '../helpers/selection';

/**
 * The "…" menu of a cue in the My Studio left panel lists (references,
 * soundtrack, sfx, mix). Without it the menu fell back to the placeholder
 * "Cancella" of ButtonIconContextMenu, which did nothing.
 *
 * Deleting also takes the cue out of the cross-panel selection, otherwise the
 * Comm Center would stay scoped to a cue that no longer exists.
 */
const useCueItemMenu = () => {
    const { projectId } = useParams();

    const deleteItem = useCallback(async (itemId) => {
        await storeSet('deleteCueSheetItem', projectId, itemId);

        const selection = storeGet('selection');

        if (selection?.ids?.includes(itemId)) {
            const ids = selection.ids.filter(id => id !== itemId);

            storeSet('selection', ids.length
                ? { ...selection, ids, anchor: ids.includes(selection.anchor) ? selection.anchor : ids[ids.length - 1] }
                : EMPTY_SELECTION);
        }
    }, [projectId]);

    return useCallback((item) => [
        { label: __('Cancella', 'soundbetween'), onClick: () => deleteItem(item.id) },
    ], [deleteItem]);
};

export default useCueItemMenu;
